module.exports = __webpack_public_path__ + "static/cta-moc-1-1-b80259f552f64975f9495ce9ceb92d5a.png";